import { FC, memo } from 'react';
import { Accordion, Flex, Icon, Text, useSlotRecipe } from '@chakra-ui/react';

import { useAccordionRadioGroupRenderableIcon } from '../hooks/useAccordionRadioGroupRenderableIcon';
import { AccordionRadioGroupsSelecterItemTitleProps } from './types/AccordionRadioGroupsSelecterItemTitleProps';

const AccordionRadioGroupsSelecterItemTitleComponent: FC<
  AccordionRadioGroupsSelecterItemTitleProps
> = ({ children, icon }) => {
  const RenderableIcon = useAccordionRadioGroupRenderableIcon(icon);
  const assetImageRecipe = useSlotRecipe({ key: 'assetImage' });
  const assetImageStyles = assetImageRecipe();

  return (
    <h3>
      <Accordion.ItemTrigger>
        <Flex
          alignItems="center"
          justifyContent="space-between"
          paddingBlock={2}
          paddingInline={4}
          w="full"
        >
          <Flex alignItems="center" justifyContent="center">
            {icon && (
              <Icon
                as={RenderableIcon}
                boxSize={12}
                css={assetImageStyles.assetIcon}
                mr={4}
              />
            )}

            <Text fontSize="md" textAlign="left">
              {children}
            </Text>
          </Flex>

          <Accordion.ItemIndicator ml={6} mr={-1.5} />
        </Flex>
      </Accordion.ItemTrigger>
    </h3>
  );
};

export const AccordionRadioGroupsSelecterItemTitle = memo(
  AccordionRadioGroupsSelecterItemTitleComponent,
);
